import { PropsWithChildren } from 'react';
import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { helloMessage } from '../../services/constants'
import HelloSunshine from './helloSunshine';
import custom from '../../styles/mui/szVariables.json'

export default function AuthLayout({ children }: PropsWithChildren) {
    const navigate = useNavigate()
    return (
        <Box sx={{ 
                backgroundColor: {
                    xs: '#FFF',
                    sm: 'primary.main',
                    md: 'primary.main',
                    lg: 'primary.main',
                } 
            }}
            display="flex" 
            justifyContent={"center"} 
            alignItems={"center"} 
            flexDirection={"row"}
            width="100vw">
             <Box display={{
                    xs: "none",
                    sm: "none",
                    md: "none",
                    lg: "flex",
                 }} 
                 justifyContent={"center"} 
                 alignItems={"center"} 
                 flexDirection={"row"} 
                 width='50vw'>
                <Box display="flex" 
                    justifyContent={"space-between"} 
                    alignItems={"flex-start"} 
                    flexDirection={"column"}
                    height="100vh"
                    width="500px">
                    <Box id="szLogo"
                        onClick={()=>navigate('/signin')}
                        sx={{
                          cursor: 'pointer'
                        }}
                        mt={custom.spacing.xl}
                        ml={custom.spacing.md}
                        component={"img"}           
                        height={custom.sizes.xxl}
                        loading="lazy"
                        alt="Solar Zero Logo"
                        src="/images/szNamedLogoWhite.svg" />
                    <Box ml={custom.spacing.md} >
                        <Box
                            component={"img"}           
                            height="102px"
                            width="273px"
                            loading="lazy"
                            alt="Hello Sunshine"
                            src="/images/HelloSunshineYellow.svg" />
                        <Typography color="#FFF"
                            component={"p"}
                            mt={custom.spacing.md}
                            variant="szBody.Regular.Medium">
                            {helloMessage}
                        </Typography>
                    </Box>
                    <Box ml={custom.spacing.md}
                        component={"img"}           
                        height="311px"
                        loading="lazy"
                        alt="Solar Zero Image"
                        src="/images/BottomImage.svg" />
                </Box>
            </Box>
            <Box display="flex" 
                justifyContent={"center"} 
                 alignItems={"center"} 
                 flexDirection={"row"} 
                 width={{
                    xs:'100vw',
                    sm:'100vw',
                    md:'100vw',
                    lg:'50vw'
                 }}
                 >
                <Box display="flex" 
                    justifyContent={{
                        xs: "flex-start",
                        sm: "flex-start",
                        md: "flex-start",
                        lg: "center",
                    }} 
                    alignItems={"center"} 
                    flexDirection={"column"}
                    height={{
                        xs: "auto",
                        sm: "auto",
                        md: "auto",
                        lg: "100vh",
                    }}
                    >
                    <HelloSunshine display={{
                        xs: "none",
                        sm: "flex",
                        md: "flex",
                        lg: "none",
                    }}/>    
                    <Box maxWidth="500px" 
                        pb={{
                            xs:20,
                            sm:50,
                            md:70,
                            lg:0
                        }}>
                        {children}
                    </Box>    
                </Box>
            </Box>
        </Box>
      );
}
